import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import type { Persistor } from 'redux-persist';
import type { Store } from 'redux';
import rootReducer from './root-reducer';
import type { RootState } from './root-reducer';
import rootSaga from './root-saga';

/* Use require(...).default for the saga middleware factory to avoid the
   ESM/CJS interop crash under CRA's build. */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const createSagaMiddleware = require('redux-saga').default as () => {
  run: (saga: () => Generator) => void;
};

const sagaMiddleware = createSagaMiddleware();

export const store: Store = createStore(rootReducer, applyMiddleware(sagaMiddleware as never));
sagaMiddleware.run(rootSaga);

export const persistor: Persistor = persistStore(store);

export type { RootState };
